import { Box, CSS } from '@project44/manifest-ds';

interface IAccentBox {
  bgColor?: string;
  css?: CSS;
}

function AccentBox({ bgColor = '$primary-default', css }: IAccentBox) {
  return (
    <Box
      data-testid="accent-box"
      css={{
        bgColor,
        borderRadius: '$small',
        height: 24,
        width: 8,
        lineHeight: 0,
        ...css,
      }}
    />
  );
}

export default AccentBox;
